export function identifyPrimaryService(corporateClientInfo){
    if (corporateClientInfo?.services == null) return null;

    let services = corporateClientInfo.services.filter((service => service.type === corporateClientInfo.type));
    return services.length > 0 ? services[0] : null;
}

export const anyServiceCorporate = (corporateClientInfo) => {
    if (corporateClientInfo?.services == null) return null;

    return corporateClientInfo.services
        .filter((service => service.type === corporateClientInfo.type))
        .find(service => service.corporate)
}

export const corporateRegex = /^[a-z,\d,-]{36}$/;